import Plyr from "plyr";

function formatDuration(seconds) {
  if (!Number.isFinite(seconds) || seconds < 0) return '0:00'
  const total = Math.round(seconds)
  const minutes = Math.floor(total / 60)
  const rest = String(total % 60).padStart(2, '0')
  return `${minutes}:${rest}`
}

function bindProfileVideo(media) {
  if (media.dataset.bound) return
  media.dataset.bound = 'true'

  const video = media.querySelector('.js-profile-video')
  const play = media.querySelector('.js-video-play')
  const time = media.querySelector('.js-video-time')
  if (!video || !play) return

  const syncTime = () => {
    if (time) time.textContent = formatDuration(video.duration)
  }

  video.addEventListener('loadedmetadata', syncTime)
  if (video.readyState >= 1) syncTime()

  const pauseOthers = () => {
    document.querySelectorAll('.js-video-media.is-playing').forEach((other) => {
      if (other === media) return
      const otherVideo = other.querySelector('.js-profile-video')
      if (otherVideo) otherVideo.pause()
    })
  }

  const enterPlaying = () => {
    pauseOthers()
    media.classList.add('is-playing')
  }

  const leavePlaying = () => {
    media.classList.remove('is-playing')
  }

  play.addEventListener('click', (event) => {
    event.preventDefault()
    event.stopPropagation()
    video.play()
  })

  media.addEventListener('click', () => {
    if (video.paused) {
      video.play()
    } else {
      video.pause()
    }
  })

  video.addEventListener('play', enterPlaying)
  video.addEventListener('pause', leavePlaying)
  video.addEventListener('ended', () => {
    leavePlaying()
    video.currentTime = 0
  })
}

function loadPlyrPlayers() {
  const players = Plyr.setup('.js-player', {
    controls: ['play', 'progress', 'fullscreen', 'current-time']
  });

  if (!players) return;

  players.forEach((player) => {
    player.on('play', () => {
      players.forEach((p) => {
        if (p !== player) p.pause();
      });
    });
  });
}

function loadPlayer() {
  loadPlyrPlayers();
  document.querySelectorAll('.js-video-media').forEach(bindProfileVideo);
}

document.addEventListener("turbolinks:load", function () {
  window.loadPlayer = loadPlayer
  loadPlayer()
})
